import { tsValidateArray, tsValidateEnum, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { LLMAnswerType, ProviderChatInteractionStatus } from './types.js';
import { Validator_EncounterId } from '../_core/validator.js';
import { AdvisorRuntimeIDBGroup } from '../_core/consts.js';
const Validator_LLMAnswer = {
    answer: tsValidateString(),
    type: tsValidateEnum(LLMAnswerType),
};
const Validator_ProvideChatInteraction = {
    ...Validator_EncounterId,
    chatId: tsValidateUniqueId,
    prompt: tsValidateString(),
    answers: tsValidateArray(Validator_LLMAnswer),
    status: tsValidateEnum(ProviderChatInteractionStatus, false),
    errorMessage: tsValidateString(undefined, false),
};
const Validator_GeneratedProps = {};
export const DBDef_ProviderChatInteraction = {
    modifiablePropsValidator: Validator_ProvideChatInteraction,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'provider-chat-interaction',
    entityName: 'Provider Chat Interaction',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'provider-chat-interaction'
    },
    backend: {
        name: 'provider-chat-interaction'
    }
};
//# sourceMappingURL=db-def.js.map